export default __webpack_public_path__ + "static/media/testimonials-02.77fafee7.jpg";